module.exports = __webpack_public_path__ + "img/160.2960d2cc.jpg";